import AnimeshHarshit from "../AnimeshHarshit";
import ApplianceRender from "../ApplianceRender";

const DSA = () => {
    return (
        <ApplianceRender roomName={"DsaBhaggu"}/>
    )
}

export default DSA